import React from 'react';

const Footer: React.FC = () => {
  const openPrivacySettings = () => {
    (
      window as typeof window & { openConsentSettings?: () => void }
    ).openConsentSettings?.();
  };

  return (
    <footer className="bg-base-200 border-t border-base-300">
      <div className="container mx-auto px-4 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="flex flex-wrap gap-6 mb-4 md:mb-0">
            <a
              href="/"
              className="text-neutral hover:text-primary transition-colors"
            >
              HOME
            </a>
            <a
              href="/products"
              className="text-neutral hover:text-primary transition-colors"
            >
              PRODUCTS
            </a>
            <a
              href="/stores"
              className="text-neutral hover:text-primary transition-colors"
            >
              STORES
            </a>
            <a
              href="/resorts"
              className="text-neutral hover:text-primary transition-colors"
            >
              RESORTS
            </a>
            <a
              href="/hotels"
              className="text-neutral hover:text-primary transition-colors"
            >
              HOTELS
            </a>
            <a
              href="/restaurants"
              className="text-neutral hover:text-primary transition-colors"
            >
              RESTAURANTS
            </a>
            <a
              href="/podcasts"
              className="text-neutral hover:text-primary transition-colors"
            >
              PODCASTS
            </a>
            <a
              href="/games/theme-park-guess"
              className="text-neutral hover:text-primary transition-colors"
            >
              GAME
            </a>
            <a
              href="/episodes"
              className="text-neutral hover:text-primary transition-colors"
            >
              LATEST EPISODES
            </a>
            <a
              href="/about-us"
              className="text-neutral hover:text-primary transition-colors"
            >
              ABOUT
            </a>
            <button
              type="button"
              className="text-neutral hover:text-primary transition-colors"
              onClick={openPrivacySettings}
            >
              PRIVACY SETTINGS
            </button>
          </div>
          <div className="text-center md:text-right">
            <div className="text-sm text-neutral/70">
              Copyright © 2025 - Roller Coaster Gifts
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
